import { useLocation } from 'react-router-dom'
import { routes } from '../../navigation'
import { MenuOption } from './sideMenu.props'
import { useTranslation } from '@hooks'
import { useMenuIcons } from 'hooks/useMenuIcons'
import { JSX } from 'react'
import React from 'react'

interface IconPair {
  filled: JSX.Element
  outline: JSX.Element
}

export const useMenuOptions = (): MenuOption[] => {
  const { pathname } = useLocation()
  const { t } = useTranslation()

  const activeStyle = (route: string, type: string): string => {
    const activeStyle = `navbar__${type}--active`
    return `navbar__${type} ${pathname.includes(route) ? activeStyle : ''}`
  }

  const getIcon = (isActive: boolean, icons: IconPair): JSX.Element => {
    const iconType = isActive ? icons.filled : icons.outline
    const className = `navbar__logo${isActive ? ' navbar__logo--active' : ''}`
    return React.cloneElement(iconType, {
      className: className,
    })
  }

  const icons = useMenuIcons()
  const homeIsActive = routes.auth.home === pathname
  const discoverIsActive = pathname.includes('discover')
  const transactionsIsActive = pathname.includes('transactions')
  const watchlistIsActive = routes.auth.watchlist === pathname
  const portfolioIsActive = routes.auth.portfolio === pathname
  const profileIsActive = routes.auth.profile === pathname

  return [
    {
      active: homeIsActive,
      name: t('home.title'),
      navigateTo: routes.auth.home,
      logo: getIcon(homeIsActive, icons.home),
      optionStyle: activeStyle(routes.auth.home, 'option'),
    },
    {
      active: discoverIsActive,
      name: t('discover.menu'),
      navigateTo: routes.auth.discoverAll,
      logo: getIcon(discoverIsActive, icons.discover),
      optionStyle: activeStyle('discover', 'option'),
    },
    {
      active: transactionsIsActive,
      name: t('transactions.title'),
      navigateTo: routes.auth.transactionsExecuted,
      logo: getIcon(transactionsIsActive, icons.transactions),
      optionStyle: activeStyle('transactions', 'option'),
    },
    {
      active: watchlistIsActive,
      name: t('watchlist.title'),
      navigateTo: routes.auth.watchlist,
      logo: getIcon(watchlistIsActive, icons.watchlist),
      optionStyle: activeStyle(routes.auth.watchlist, 'option'),
    },
    {
      active: portfolioIsActive,
      name: t('common.portfolio'),
      navigateTo: routes.auth.portfolio,
      logo: getIcon(portfolioIsActive, icons.portfolio),
      optionStyle: activeStyle(routes.auth.portfolio, 'option'),
    },
    {
      active: profileIsActive,
      name: t('profile.title'),
      navigateTo: routes.auth.profile,
      logo: getIcon(profileIsActive, icons.profile),
      optionStyle: activeStyle(routes.auth.profile, 'option'),
    },
  ]
}
